<div class="main-content">
  <app-header [title]="(isEdit ? 'REQ_DOC_FORM.EDIT_TITLE' : 'REQ_DOC_FORM.CREATE_TITLE') | translate" />

  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">
      <!-- Form Container -->
      @if (!isSuccess && !isError && !deleteSuccess && !deleteError) {
        <app-icam-container [centralIcon]="true" [iconName]="'article'" [iconColor]="'#e30714'" [iconHeight]="'32px'">
          @if (!isLoading) {
            <div>
              <form
                [formGroup]="form"
                (ngSubmit)="onSubmit()"
                class="form-container required-document-form d-flex flex-column"
              >
                <div class="form-section required-doc-section w-100">
                  <div class="d-flex align-items-center form-title mt-2" [ngClass]="isLight ? 'light' : 'dark'">
                    <div class="d-flex align-items-center p-2">
                      <img class="section-image" src="../../assets/icon/article.svg" alt="article" />
                    </div>
                    <div class="form-title-text-container">
                      <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                        {{ 'REQ_DOC_FORM.DOC_DATA' | translate }}
                      </p>
                    </div>
                  </div>
                  <!-- Document Name -->
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="reqDocName">{{ 'REQ_DOC_FORM.DOC_NAME' | translate }}*</label>
                        <app-icam-input
                          label="{{ 'REQ_DOC_FORM.DOC_NAME' | translate }}"
                          inputId="reqDocName"
                          [isSlim]="true"
                          inputType="text"
                          formControlName="reqDocName"
                          [placeholder]="'REQ_DOC_FORM.DOC_NAME_PLACEHOLDER' | translate"
                          [ngClass]="isLight ? 'light' : 'dark'"
                          [required]="true"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- Display Order -->
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="displayOrder">{{ 'REQ_DOC_FORM.ORDER' | translate }}*</label>
                        <app-icam-input
                          label="{{ 'REQ_DOC_FORM.ORDER' | translate }}"
                          inputId="displayOrder"
                          [isSlim]="true"
                          inputType="number"
                          formControlName="displayOrder"
                          [ngClass]="isLight ? 'light' : 'dark'"
                          [min]="1"
                          [step]="1"
                          [required]="true"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- Customer Can Upload -->
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="customerCanUpload">{{ 'REQ_DOC_FORM.CAN_UPLOAD' | translate }}</label>
                        <select id="customerCanUpload" class="form-select" formControlName="customerCanUpload">
                          <option [ngValue]="true">{{ 'COMMON.YES' | translate }}</option>
                          <option [ngValue]="false">{{ 'COMMON.NO' | translate }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- Uploadable Periodically -->
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="uploadablePeriodically">{{ 'REQ_DOC_FORM.PERIODIC' | translate }}</label>
                        <select id="uploadablePeriodically" class="form-select" formControlName="uploadablePeriodically">
                          <option [ngValue]="true">{{ 'COMMON.YES' | translate }}</option>
                          <option [ngValue]="false">{{ 'COMMON.NO' | translate }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- Associated to Machine -->
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="associatedToMachine">{{ 'REQ_DOC_FORM.ASSOCIATED_MACHINE' | translate }}</label>
                        <select id="associatedToMachine" class="form-select" formControlName="associatedToMachine">
                          <option [ngValue]="true">{{ 'COMMON.YES' | translate }}</option>
                          <option [ngValue]="false">{{ 'COMMON.NO' | translate }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- Machine Typologies -->
                  @if (form.get('associatedToMachine')?.value === true) {
                    <div class="row">
                      <div class="col-12">
                        <div class="input-wrapper">
                          <label for="machineTypologies">{{ 'REQ_DOC_FORM.MACHINE_TYPOLOGIES' | translate }}</label>
                          <app-multi-select-autocomplete
                            formControlName="machineTypologies"
                            [options]="(typologyOptions$ | async) ?? []"
                            [displayField]="'name'"
                            [filterFields]="['name']"
                            [required]="false"
                            [fetchFn]="fetchTypologies"
                          ></app-multi-select-autocomplete>
                        </div>
                      </div>
                    </div>
                  }
                  <!-- Notes -->
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="notes">{{ 'REQ_DOC_FORM.NOTES' | translate }}</label>
                        <textarea
                          class="form-control"
                          id="notes"
                          formControlName="notes"
                          rows="3"
                          placeholder="Aggiungi una nota..."
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <!-- Template File -->
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="template">{{ 'REQ_DOC_FORM.TEMPLATE' | translate }}</label>
                        <div class="d-flex align-items-center gap-2">
                          <label for="template" class="custom-file-upload" [ngClass]="isLight ? 'light' : 'dark'">
                            <app-icam-icon iconName="attachment" />
                            {{ 'REQ_DOC_FORM.CHOOSE_TEMPLATE_FILE' | translate }}
                          </label>
                        </div>
                        <input
                          id="template"
                          type="file"
                          style="display: none"
                          (change)="onTemplateFileSelected($event)"
                          accept=".pdf,.doc,.docx"
                        />
                        <!-- Template File Display -->
                        @if (template) {
                          <p class="text-muted" [ngClass]="isLight ? 'light' : 'dark'">
                            {{ template.name }}
                            <small
                              class="text-decoration-underline"
                              role="button"
                              (click)="removeTemplateAttachment()"
                              (keydown.enter)="removeTemplateAttachment()"
                              tabindex="0"
                            >
                              ({{ 'COMMON.REMOVE' | translate }})
                            </small>
                          </p>
                        }
                        @if (!template && existingTemplate) {
                          <p class="text-muted" [ngClass]="isLight ? 'light' : 'dark'">
                            {{ existingTemplate.fileName }}
                            <small
                              class="text-decoration-underline"
                              role="button"
                              (click)="removeTemplateAttachment()"
                              (keydown.enter)="removeTemplateAttachment()"
                              tabindex="0"
                            >
                              ({{ 'COMMON.REMOVE' | translate }})
                            </small>
                          </p>
                        }
                      </div>
                    </div>
                  </div>
                  <!-- Submit Button -->
                  <button
                    type="submit"
                    class="button-form-submit"
                    [class.disabled]="!form.valid || !isAttachmentsValid() || isLoading"
                    [disabled]="!form.valid || !isAttachmentsValid() || isLoading"
                  >
                    @if (isLoading) {
                      <div class="d-flex justify-content-center">
                        <div class="spinner-border spinner-border-sm" role="status"></div>
                      </div>
                    } @else {
                      {{ isEdit ? ('REQ_DOC_FORM.SAVE_CHANGES' | translate) : ('REQ_DOC_FORM.CREATE_DOC' | translate) }}
                    }
                  </button>
                </div>
              </form>
            </div>
          }
          <!-- Loading State -->
          @if (isLoading) {
            <div class="loading-container text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
              </div>
              <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
            </div>
          }
        </app-icam-container>
      }

      <!-- Success States -->
      @if (isSuccess && !deleteSuccess) {
        <app-icam-container [centralIcon]="true" [iconName]="'OK'" [iconColor]="'#00A5A9'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              {{ (isEdit ? 'REQ_DOC_FORM.UPDATE_SUCCESS' : 'REQ_DOC_FORM.CREATE_SUCCESS') | translate }}
            </h1>
            <p class="subtitle my-3">
              {{
                (isEdit ? 'REQ_DOC_FORM.UPDATED_DOC_DESCRIPTION' : 'REQ_DOC_FORM.CREATED_DOC_DESCRIPTION') | translate
              }}
            </p>
            <button class="btn btn-primary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      @if (deleteSuccess) {
        <app-icam-container [centralIcon]="true" [iconName]="'OK'" [iconColor]="'#00A5A9'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              @if (isDeletingOperation) {
                {{ 'REQ_DOC_FORM.DELETE_SUCCESS' | translate }}
              } @else {
                {{ getToggleSuccessTitle() | translate }}
              }
            </h1>
            <p class="subtitle my-3">
              @if (isDeletingOperation) {
                {{ 'REQ_DOC_FORM.DELETED_DOC_DESCRIPTION' | translate }}
              } @else {
                {{ getToggleSuccessDescription() | translate }}
              }
            </p>
            <button class="btn btn-primary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      <!-- Error States -->
      @if (isError && !deleteError) {
        <app-icam-container [centralIcon]="true" [iconName]="'KO'" [iconColor]="'#e30714'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ (isEdit ? 'REQ_DOC_FORM.UPDATE_ERROR' : 'REQ_DOC_FORM.CREATE_ERROR') | translate }}
            </h1>
            <p class="subtitle my-3">
              {{
                (isEdit ? 'REQ_DOC_FORM.UPDATE_ERROR_DESCRIPTION' : 'REQ_DOC_FORM.CREATE_ERROR_DESCRIPTION') | translate
              }}
            </p>
            @if (errorMessage) {
              <div class="text-danger validation-errors">
                @for (line of errorMessage.split('\n'); track line) {
                  <p>{{ line }}</p>
                }
              </div>
            }
            <div class="d-flex mt-3 gap-3">
              <button class="btn btn-primary" (click)="isError = false">
                {{ 'COMMON.TRY_AGAIN' | translate }}
              </button>
              <button class="btn btn-outline-primary" (click)="goToList()">
                {{ 'COMMON.RETURN_TO_LIST' | translate }}
              </button>
            </div>
          </div>
        </app-icam-container>
      }

      @if (deleteError) {
        <app-icam-container [centralIcon]="true" [iconName]="'KO'" [iconColor]="'#e30714'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ getDeleteErrorTitle() | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ getDeleteErrorDescription() | translate }}
            </p>
            @if (errorMessage) {
              <div class="text-danger validation-errors">
                @for (line of errorMessage.split('\n'); track line) {
                  <p>{{ line }}</p>
                }
              </div>
            }
            <div class="d-flex mt-3 gap-3">
              <button class="btn btn-primary" (click)="deleteError = false; isError = false">
                {{ 'COMMON.TRY_AGAIN' | translate }}
              </button>
              <button class="btn btn-outline-primary" (click)="goToList()">
                {{ 'COMMON.RETURN_TO_LIST' | translate }}
              </button>
            </div>
          </div>
        </app-icam-container>
      }

      <!-- Footer Actions -->
      <div class="form-footer d-flex justify-content-between mt-4">
        <app-back-button
          class="app-back-button"
          [linkText]="'REQ_DOC_FORM.BACK_TO_LIST' | translate"
          (click)="goBack()"
        ></app-back-button>

        @if (isEdit && !isSuccess && !isError && !deleteSuccess && !deleteError && _requiredDocument) {
          <div class="d-flex gap-2">
            <button
              type="button"
              [ngClass]="isLight ? 'btn btn-outline-danger' : 'btn btn-outline-light'"
              (click)="openDeleteModal()"
              [class.disabled]="isLoading || !_requiredDocument"
              [disabled]="isLoading || !_requiredDocument"
            >
              @if (isLoading) {
                <div class="d-flex justify-content-center">
                  <div class="spinner-border spinner-border-sm" role="status"></div>
                </div>
              } @else {
                {{ 'REQ_DOC_FORM.DELETE_BUTTON' | translate }}
              }
            </button>
            <button
              type="button"
              [ngClass]="isLight ? 'btn btn-outline-danger' : 'btn btn-outline-light'"
              (click)="toggleRequiredDocumentActivation()"
              [class.disabled]="isLoading || !_requiredDocument"
              [disabled]="isLoading || !_requiredDocument"
            >
              @if (isLoading) {
                <div class="d-flex justify-content-center">
                  <div class="spinner-border spinner-border-sm" role="status"></div>
                </div>
              } @else {
                {{ getToggleButtonText() | translate }}
              }
            </button>
          </div>
        }
      </div>

      <!-- Delete Confirmation Modal -->
      @if (showDeleteModal) {
        <div 
          class="modal-overlay d-flex align-items-center justify-content-center" 
          (click)="closeDeleteModal()"
          (keydown.escape)="closeDeleteModal()"
          role="presentation"
        >
          <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
          <div 
            class="modal-content" 
            (click)="$event.stopPropagation()"
            role="dialog"
            aria-labelledby="deleteModalTitle"
            aria-modal="true"
            tabindex="-1"
          >
            <div class="modal-header">
              <h5 class="modal-title" id="deleteModalTitle">{{ 'REQ_DOC_FORM.DELETE_CONFIRMATION_TITLE' | translate }}</h5>
              <button
                type="button"
                class="btn-close"
                aria-label="Close"
                (click)="closeDeleteModal()"
                (keydown.enter)="closeDeleteModal()"
                (keydown.space)="$event.preventDefault(); closeDeleteModal()"
              ></button>
            </div>
            <div class="modal-body">
              <p class="mb-2">
                {{ 'REQ_DOC_FORM.DELETE_CONFIRMATION_MESSAGE' | translate }}
              </p>
              <p class="modal-warning-text">
                {{ 'REQ_DOC_FORM.DELETE_WARNING' | translate }}
              </p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                (click)="closeDeleteModal()"
                (keydown.enter)="closeDeleteModal()"
                (keydown.space)="$event.preventDefault(); closeDeleteModal()"
                [disabled]="isLoading"
              >
                {{ 'COMMON.CANCEL' | translate }}
              </button>
              <button
                type="button"
                class="btn btn-danger"
                (click)="confirmDelete()"
                (keydown.enter)="confirmDelete()"
                (keydown.space)="$event.preventDefault(); confirmDelete()"
                [disabled]="isLoading"
              >
                @if (isLoading) {
                  <div class="d-flex align-items-center gap-2">
                    <div class="spinner-border spinner-border-sm" role="status"></div>
                    <span>{{ 'COMMON.DELETING' | translate }}</span>
                  </div>
                } @else {
                  {{ 'REQ_DOC_FORM.DELETE_CONFIRM_BUTTON' | translate }}
                }
              </button>
            </div>
          </div>
        </div>
      }

    </div>
  </div>
</div>
<app-footer-copyright />
